import {ServiceRequest} from "../utils/service-request"
import {MOTOR_CADASTRO_EMISSOES_PATH} from "../utils/api-routes"

export class MotorEmissaoService {

    constructor() {
        this.request = new ServiceRequest()
    }

    async loadEmissoes(cetip_isin = null, {limit = 25, offset = 0} = {}) {
        const params = {limit, offset,}
        if (cetip_isin) {
            params.cetip_isin = cetip_isin
        }

        const query = new URLSearchParams(params).toString()
        return this.request.get(
            `${MOTOR_CADASTRO_EMISSOES_PATH}?${query}`
        )
    }

    async getEmissaoDetalhe(cetip_isin) {
        const params = new URLSearchParams()

        if (cetip_isin) params.append("cetip_isin", cetip_isin)

        const query = params.toString() ? `?${params.toString()}` : ""
        const path = `${MOTOR_CADASTRO_EMISSOES_PATH}/detalhe${query}`

        return this.request.get(path)
    }

    async getGarantias(cetip_isin) {
        const hoje = new Date().toISOString().split("T")[0]

        const params = new URLSearchParams({
            cetip_isin,
            data_referencia: hoje,
        })

        return this.request.get(
            `${MOTOR_CADASTRO_EMISSOES_PATH}/garantias?${params.toString()}`
        )
    }

    async getTipoOferta(cetip_isin) {
        const params = new URLSearchParams()

        if (cetip_isin) params.append("cetip_isin", cetip_isin)

        const query = params.toString() ? `?${params.toString()}` : ""

        return this.request.get(`${MOTOR_CADASTRO_EMISSOES_PATH}/tipo-oferta${query}`)
    }

    async getFatosRelevantes(cetip_isin) {
        const params = new URLSearchParams()

        if (cetip_isin) params.append("cetip_isin", cetip_isin)

        const query = params.toString() ? `?${params.toString()}` : ""

        return this.request.get(`${MOTOR_CADASTRO_EMISSOES_PATH}/fatos-relevantes${query}`)
    }
}